import { TSimilarCompaniesResponse } from "@/frontend/features/Company/model/types/types";
import $api from "@/frontend/shared/api/axios";
import { SimilarCompaniesResponseSchema } from "@/libs/models/companies";

const preprocessSimilarCompanies = (data: unknown) => {
  if (data && typeof data === "object" && "companies" in data && Array.isArray(data.companies)) {
    data = {
      ...data,
      companies: data.companies.map((company: any) => {
        if (
          company &&
          typeof company === "object" &&
          "similarCompany" in company &&
          typeof company.similarCompany === "object"
        ) {
          return {
            ...company.similarCompany,
            similarCompany: company.similarCompany
          };
        }
        return company;
      })
    };
  }
  return data;
};

export async function getPortfolioCompanySimilarCompanies({ id }: { id: number }) {
  const response = await $api.get<{ data: TSimilarCompaniesResponse }>(`/portfolio-companies/${id}/similar-companies`);
  const parsed = SimilarCompaniesResponseSchema.parse(preprocessSimilarCompanies(response.data.data));
  return parsed;
}
